module.exports = __webpack_public_path__ + "static/img/chuangxin.b2dd006c.png";